export default __webpack_public_path__ + "static/form-multiple-action-buttons-dont-f4080ef018783dbb6a07c95415cb8fbafa3d3ccd87016e1dcc12cceb267d3071.png";